module.exports = __webpack_public_path__ + "static/media/top_shape_4_mob.b38c5a91.svg";